<template>
  <div v-if="!disabled">
    <div v-if="label=='全部' || select.initial == '0'" @click='click(value)' :class="['general-item',{'hq-general-item':HQ},(select.value&&select.value.length == '0'||select.value=='0') && 'selected']">
      {{label}}
    </div>
    <div v-else @click="select.initial &&select.initial.indexOf(value) == -1 ? '1': click(value)" :class="['general-item', {'hq-general-item':HQ},check(value) && 'selected',select.initial &&select.initial.indexOf(value) == -1 && 'not-allowed' ]">{{label}}</div>
  </div>
  <div v-else>
    <div :class="['general-item',{'hq-general-item':HQ},'not-allowed']">{{label}}</div>
  </div>
</template>
<script>
export default {
  props: ['label', 'value', 'disabled'],
  inject: ['select'],
  data(){
return{
}
  },
  methods: {
    click(value) {
      this.select.onSelect(value);
    },
    check(val) {
      if (this.select.multiple) {
        return this.select.value.indexOf(val) != -1;
      } else {
        return this.select.value == val;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.general-item {
  font-size: 14px;
  padding: 0 20px;
  position: relative;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: #5a5e66;
  height: 34px;
  line-height: 34px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  cursor: pointer;
}

.general-item.selected {
  color: var(--theme-color);
}
.hq-general-item.selected {
  color: #337ab7;
}
// .general-item.selected:after {
//   position: absolute;
//   right: 20px;
//   font-family: element-icons;
//   content: '\E611';
//   font-size: 12px;
//   font-weight: 700;
//   -webkit-font-smoothing: antialiased;
// }

.general-item.not-allowed {
  color: #999;
  background: #fff !important;
  cursor: not-allowed;
}

.general-item:not(.not-allowed).hover,
.general-item:not(.not-allowed):hover {
  background: #f5f7fa;
}
</style>





// WEBPACK FOOTER //
// src/components/clickSelect/generalItem.vue